export const en = {
    title: 'Approve Pop-up',
    content_sign: 'Click Continue to complete the signature or transaction',
    content_login: 'Click Continue to complete creating or connecting wallet',
};
